module.exports = __webpack_public_path__ + "img/laurent.7f09f207.jpg";